import React from "react";
import { CustomToast } from "@/components/common/CustomToast";
import { StaticImageData } from "next/image";
import { ReactNode } from "react";
import { toast, ToastOptions } from "react-toastify";

export type Data = {
  text: string | ReactNode;
  lang?: string;
  imgUrl?: string;
  imageSrc?: string;
  icon?: StaticImageData;
  hideImage?: boolean;
  bgColor?: string;
  redirectUrl?: string;
};

export const useCustomToast = () => {
  const showToast = (data: Data, options?: ToastOptions) => {
    toast(CustomToast, {
      data: {
        text: data.text,
        lang: data.lang,
        icon: data.icon,
        imgUrl: data.imgUrl,
        imageSrc: data.imageSrc,
        hideImage: data.hideImage,
        bgColor: data.bgColor,
        redirectUrl: data.redirectUrl,
      },
      pauseOnHover: true,
      pauseOnFocusLoss: false,
      ...options
    });
  };

  return { showToast };
};
